"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionPanel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AccordionPanelMixin = require("../../mixins/components/AccordionPanelMixin");
var StyledAccordionPanel = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledAccordionPanel",
  componentId: "c11n-8-107-0__sc-1n2fcl1-0"
})(["", ""], _AccordionPanelMixin.AccordionPanelMixin);
exports.StyledAccordionPanel = StyledAccordionPanel;